import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "subtotal", "taxAmount", "total", "taxRate"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.recalculate()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-line-item-row]")
    const destroyInput = row.querySelector("input[name*='_destroy']")

    if (destroyInput) {
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
    this.recalculate()
  }

  togglePricingType(event) {
    const row = event.target.closest("[data-line-item-row]")
    const qtyInner = row.querySelector("[data-qty-wrapper] > div")
    const qtyField = row.querySelector("[data-field='quantity']")
    const isFixed = event.target.value === "fixed"

    if (isFixed) {
      qtyField.value = "1"
      qtyInner.classList.add("invisible")
    } else {
      qtyInner.classList.remove("invisible")
    }
    this.recalculate()
  }

  recalculate() {
    let subtotal = 0

    this.containerTarget.querySelectorAll("[data-line-item-row]").forEach(row => {
      if (row.style.display === "none") return

      const pricingType = row.querySelector("[data-field='pricing-type']")?.value || "per_unit"
      const qty = pricingType === "fixed" ? 1 : (parseFloat(row.querySelector("[data-field='quantity']")?.value) || 0)
      const rateRaw = row.querySelector("[data-field='rate']")?.value?.replace(/[^0-9.]/g, "") || "0"
      const rateCents = Math.round(parseFloat(rateRaw) * 100) || 0
      const amount = Math.round(qty * rateCents)

      const amountDisplay = row.querySelector("[data-field='amount']")
      if (amountDisplay) {
        amountDisplay.textContent = this.formatCents(amount)
      }

      subtotal += amount
    })

    const taxRate = parseFloat(this.taxRateTarget.value) || 0
    const taxAmount = Math.round(subtotal * (taxRate / 100))
    const total = subtotal + taxAmount

    this.subtotalTarget.textContent = this.formatCents(subtotal)
    this.taxAmountTarget.textContent = this.formatCents(taxAmount)
    this.totalTarget.textContent = this.formatCents(total)
  }

  formatCents(cents) {
    return "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }
}
